import styled from 'styled-components';

import { Anchor, token } from '@zillow/constellation';

export const StyledAnchor = styled(Anchor)`
  &:hover {
    text-decoration: none;
  }

  &:visited {
    color: ${token('colors.brand')};
  }
`;
